import styled from "styled-components";

export const ContainerFluid = styled.div`
  z-index: 1;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 100px;
  background-color: #f8f9fa;
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;

  border-radius: 100% 0% 100% 0% / 100px;

  @media screen and (max-width: 991px) {
    padding-right: 30px;
    padding-left: 30px;
  }
`;

export const Container = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 50px;
  padding-left: 50px;
  @media screen and (max-width: 991px) {
    padding-right: 0px;
    padding-left: 0px;
  }
`;

export const Card = styled.div`
  background: #ffffff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  margin: 50px 20px 20px 20px;
  width: calc(33.3333% - 40px); /* 1/3 minus the margins (20+20) */
  height: 350px;
  padding: 20px;
  color: #495057;
  float: left;
  display: flex;
  align-items: center;
  transition: all 0.5s ease;

  @media screen and (max-width: 1400px) {
    margin: 10px 20px;
    justify-content: center;
    width: calc(50% - 40px);
  }
  @media screen and (max-width: 768px) {
    justify-content: center;
    height: 100%;
    text-align: center;
    width: calc(100% - 40px);
    &:first-child {
      margin-top: 20px;
    }
  }
  &:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0);
    transition: all 0.5s ease;
    cursor: pointer;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  margin: 0 -15px -15px -15px;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: ${({ imgStart }) => (imgStart ? "row-reverse" : "row")};
`;

export const InfoColumn = styled.div`
  margin-bottom: 15px;
  padding-right: 15px;
  padding-left: 15px;
  flex: 1;
  max-width: 50%;
  flex-basis: 50%;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    flex-basis: 100%;
    display: flex;
    justify-content: center;
  }
`;

export const ImgWrapper = styled.div`
  max-width: 555px;
  display: flex;
`;

export const Img = styled.img`
  padding-right: 0;
  border: 0;
  width: 150px;
  height: 230px;
  border-radius: 5px;
  vertical-align: middle;
  display: inline-block;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding: 7px;
`;

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 16px;
  line-height: 1.1;
  line-height: 1.5;
  color: #495057;
  @media screen and (max-width: 768px) {
    font-size: 18px;
  }
`;

export const InfoLabel = styled.h1`
  margin-bottom: 24px;
  font-size: 12px;
  line-height: 1.1;
  font-weight: 1000;
  line-height: 1.5;

  color: #00afb9;
`;

export const TextSpan = styled.span`
  color: #495057;
`;
